import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { BaseSource } from './basesource';
import { AbortError } from '../utils';

var ArrayBufferSource =
/*#__PURE__*/
function (_BaseSource) {
  _inherits(ArrayBufferSource, _BaseSource);

  function ArrayBufferSource(arrayBuffer) {
    var _this;

    _classCallCheck(this, ArrayBufferSource);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ArrayBufferSource).call(this));
    _this.arrayBuffer = arrayBuffer;
    return _this;
  }

  _createClass(ArrayBufferSource, [{
    key: "fetchSlice",
    value: function fetchSlice(slice, signal) {
      if (signal && signal.aborted) {
        throw new AbortError('Request aborted');
      }

      return this.arrayBuffer.slice(slice.offset, slice.offset + slice.length);
    }
  }]);

  return ArrayBufferSource;
}(BaseSource);

export function makeBufferSource(arrayBuffer) {
  return new ArrayBufferSource(arrayBuffer);
}